import React from 'react';
import Icon from '../../../components/AppIcon';

const PlannerTypeSelector = ({ selectedType, onTypeSelect, className = "" }) => {
  const plannerTypes = [
    {
      id: 'daily',
      name: 'Daily Planner',
      description: 'Perfect for day-to-day scheduling and task management',
      icon: 'Calendar',
      features: ['Hourly time slots', 'Task lists', 'Priority sections', 'Notes area'],
      popular: true
    },
    {
      id: 'weekly',
      name: 'Weekly Planner',
      description: 'Ideal for weekly overview and goal tracking',
      icon: 'CalendarDays',
      features: ['7-day layout', 'Goal tracking', 'Habit tracker', 'Weekly review']
    },
    {
      id: 'monthly',
      name: 'Monthly Planner',
      description: 'Great for long-term planning and project management',
      icon: 'CalendarRange',
      features: ['Monthly calendar', 'Project tracking', 'Milestone markers', 'Budget planning']
    },
    {
      id: 'custom',
      name: 'Custom Layout',
      description: 'Create your own unique planner design',
      icon: 'Settings',
      features: ['Flexible sections', 'Custom templates', 'Personalized layout', 'Advanced options']
    }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {plannerTypes?.map((type) => (
          <div
            key={type?.id}
            onClick={() => onTypeSelect(type?.id)}
            className={`
              relative p-6 rounded-lg border-2 cursor-pointer transition-all duration-200
              hover:shadow-md hover:scale-[1.02]
              ${selectedType === type?.id
                ? 'border-primary bg-primary/5 shadow-md'
                : 'border-border bg-card hover:border-primary/50'
              }
            `}
          >
            {type?.popular && (
              <div className="absolute -top-2 -right-2 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-semibold">
                Popular
              </div>
            )}
            
            <div className="flex items-start space-x-4">
              <div className={`
                w-12 h-12 rounded-lg flex items-center justify-center
                ${selectedType === type?.id ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}
              `}>
                <Icon name={type?.icon} size={24} />
              </div>
              
              <div className="flex-1">
                <h3 className="font-heading font-semibold text-lg text-foreground mb-2">
                  {type?.name}
                </h3>
                <p className="font-body text-sm text-muted-foreground mb-4">
                  {type?.description}
                </p>
                
                <div className="space-y-2">
                  {type?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <Icon name="Check" size={14} className="text-success" />
                      <span className="font-caption text-xs text-muted-foreground">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className={`
                w-6 h-6 rounded-full border-2 flex items-center justify-center
                ${selectedType === type?.id
                  ? 'border-primary bg-primary' :'border-muted-foreground'
                }
              `}>
                {selectedType === type?.id && (
                  <Icon name="Check" size={14} color="white" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlannerTypeSelector;